import RegistrationData from '@/classes/facturae/RegistrationData'
import PersonType from '@/classes/facturae/PersonType'
import ResidenceType from '@/classes/facturae/ResidenceType'
import Business from '@/classes/facturae/Business'
import Address from '@/classes/facturae/Address'
import ContactDetails from '@/classes/facturae/ContactDetails'
import TaxWithHeld from '@/classes/facturae/TaxWithHeld'
import InvoiceLine from '@/classes/facturae/InvoiceLine'
import Descuento from '@/classes/facturae/Descuento'
import Tax from '@/classes/facturae/Tax'
import SimplificadaData from '@/classes/facturae/SimplificadaData'

import convertFileToBase64 from '@/services/functions/convertFileToBase64'
import getNullableNumber from '@/services/functions/getNullableNumber'
import { preserveByPredicate } from '@/services/functions/preserve&discard'

async function getPayloadSimplificada (form, { includeFiles = true, overrideTemplate = null } = {}) {
  const payload = new SimplificadaData()
  payload.serieFactura = form.serieFactura || null
  payload.numFactura = form.numFactura || null
  payload.dateEmision = form.dateEmision || null
  payload.albaran = form.albaran || null
  payload.pedido = form.pedido || null
  payload.tipoImpuestoFactura = form.tipoImpuestoFactura || null
  payload.observaciones = form.observaciones || null
  payload.numExpediente = form.numExpediente || null
  payload.dateExpediente = form.dateExpediente || null
  payload.numEmisor = form.numEmisor || null
  payload.dateEmisor = form.dateEmisor || null
  payload.codAsignacion = form.codAsignacion || null
  payload.dateReceptor = form.dateReceptor || null
  payload.dir3 = form.dir3 || null
  payload.numContrato = form.numContrato || null
  payload.codDepReceptor = form.codDepReceptor || null
  payload.cuotaSuplido = form.cuotaSuplido || null
  payload.periodoDesde = form.periodoDesde || null
  payload.periodoHasta = form.periodoHasta || null
  //   payload.tipoAsociado = form.tipoAsociado || null // TODO -> ¿Qué es?
  //   payload.fechaAplicacion = form.fechaAplicacion || null // TODO -> ¿Qué es?
  payload.idPlantilla = (overrideTemplate || form.template)?.idPlantilla || null
  payload.applyEquivalenceSurcharge = !!form.applyEquivalenceSurcharge

  if (form.issuer) {
    const formIssuer = form.issuer
    const seller = new Business()
    const address = new Address()
    address.AddressLine = formIssuer.Direccion || null
    address.PostCode = formIssuer.CodigoPostal || null
    address.Town = formIssuer.Poblacion || null
    address.Province = formIssuer.Provincia || null
    address.CountryCode = formIssuer.CodigoPais || null
    seller.Address = address

    const contactDetails = new ContactDetails()
    contactDetails.Telephone = formIssuer.Telefono || null
    seller.ContactDetails = contactDetails

    seller.IdCIFEmpresa = formIssuer.IdCIFEmpresa || null
    seller.CorporateName = formIssuer.RazonSocial || null
    seller.PersonName = formIssuer.PersonaFisicaNombre || null
    seller.FirstSurname = formIssuer.PersonaFisicaPrimerApellido || null
    seller.SecondSurname = formIssuer.PersonaFisicaSegundoApellido || null
    seller.TIN = formIssuer.CIF || null
    seller.PersonType = formIssuer.PersonaFisica ? PersonType.FISICA : PersonType.JURIDICA
    seller.ResidenceType = formIssuer.TipoResidencia || ResidenceType.RESIDENTE

    const formRegistrationData = preserveByPredicate(formIssuer, key => key.startsWith('Registro'))
    if (Object.values(formRegistrationData).some(value => ![undefined, null].includes(value))) {
      const registrationData = new RegistrationData()
      registrationData.Book = formRegistrationData.RegistroLibro
      registrationData.RegisterOfCompaniesLocation = formRegistrationData.RegistroRegistroMercantil
      registrationData.Sheet = formRegistrationData.RegistroHoja
      registrationData.Folio = formRegistrationData.RegistroFolio
      registrationData.Section = formRegistrationData.RegistroSeccion
      registrationData.Volume = formRegistrationData.RegistroTomo
      registrationData.AdditionalData = formRegistrationData.RegistroDatosAdiccionales
      seller.RegistrationData = registrationData
    }
    payload.seller = seller
  }

  if (form.irpf) {
    const formIrpf = form.irpf
    const taxWithHeld = new TaxWithHeld()
    taxWithHeld.taxName = formIrpf.Name || null
    taxWithHeld.taxType = formIrpf.TaxType || '04'
    taxWithHeld.taxRate = getNullableNumber(formIrpf.TaxRate)
    payload.taxesWithHeld = taxWithHeld
  }

  if (form.invoiceLines?.length) {
    const formLines = form.invoiceLines
    payload.invoiceLines = []
    formLines.forEach(invoiceLine => {
      const line = new InvoiceLine()
      line.codProducto = invoiceLine.codProducto || null
      line.descripcion = invoiceLine.descripcion || null
      line.precioUnitario = getNullableNumber(invoiceLine.UnitPriceWithoutTax)
      line.cantidad = getNullableNumber(invoiceLine.cantidad)
      line.subtotal = getNullableNumber(invoiceLine.subtotal)
      line.total = getNullableNumber(invoiceLine.total)
      line.UnitOfMeasure = getNullableNumber(invoiceLine.UnitOfMeasure)
      line.totalConImpuesto = getNullableNumber(invoiceLine.totalConImpuesto)
      line.lineNumber = getNullableNumber(invoiceLine.lineNumber)
      if (invoiceLine.descuentos?.length) {
        const formDescuento = invoiceLine.descuentos[0]
        const descuento = new Descuento()
        descuento.descuento = (formDescuento.incluyeDescuento ? formDescuento.descuento : null) || null
        descuento.cuota = (formDescuento.incluyeDescuento ? null : formDescuento.cuota) || null
        if (formDescuento.incluyeDescuento ? (descuento.descuento || descuento.descuento === 0) : (descuento.cuota || descuento.cuota === 0)) {
          line.descuentos = descuento
        }
      }
      if (invoiceLine.Taxes?.length) {
        const formTaxes = invoiceLine.Taxes
        line.taxes = []
        formTaxes.forEach(lineTax => {
          const tax = new Tax()
          tax.taxType = lineTax.TaxType || null
          tax.taxRate = getNullableNumber(lineTax.TaxRate)
          tax.cuota = getNullableNumber(lineTax.cuota)
          tax.equivalenceSurcharge = form.applyEquivalenceSurcharge ? getNullableNumber(lineTax.EquivalenceSurcharge) : 0
          line.taxes.push(tax)
        })
      }
      line.AdditionalLineItemInformation = invoiceLine.additionalLineItemInformation || null
      payload.invoiceLines.push(line)
    })
  }

  if (includeFiles) {
    const checkFile = form.file?.[0] ?? form.file
    if (checkFile && !Array.isArray(checkFile)) {
      payload.file = await convertFileToBase64(checkFile)
    }
    if (form.Adjuntos?.length) {
      payload.Adjuntos = await Promise.all(form.Adjuntos.map(file => convertFileToBase64(file)))
    }
  }
  return payload
}

export default getPayloadSimplificada
